module.exports = __webpack_public_path__ + "static/img/mockup.846c454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mockup/mockup.png
// module id = RH9Z
// module chunks = 1